import { combineReducers } from "redux";
import company from "./company";

const rootReducer = combineReducers({company});

export default rootReducer;
